import script from "./statistics-cards.vue?vue&type=script&setup=true&lang=ts"
export * from "./statistics-cards.vue?vue&type=script&setup=true&lang=ts"

import "./statistics-cards.vue?vue&type=style&index=0&id=11cf13e8&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11cf13e8"]])

export default __exports__